// ============================================================
// IssueAlerts.tsx — 姿勢問題警示卡片元件
// 以視覺化方式顯示偵測到的姿勢問題及即時矯正提示
// ============================================================

import React, { FC } from 'react';
import { PostureIssue, IssueSeverity } from 'types/posture';

interface IssueAlertsProps {
    issues: PostureIssue[];
}

// 各嚴重程度的樣式設定
const SEVERITY_STYLES: Record<IssueSeverity, { border: string; bg: string; icon: string; label: string }> = {
    [IssueSeverity.HIGH]:   { border: '#FF4444', bg: 'rgba(255,68,68,0.1)',   icon: '🔴', label: '立即矯正' },
    [IssueSeverity.MEDIUM]: { border: '#FF8C00', bg: 'rgba(255,140,0,0.1)',  icon: '🟠', label: '需要注意' },
    [IssueSeverity.LOW]:    { border: '#00AAFF', bg: 'rgba(0,170,255,0.1)',  icon: '🔵', label: '建議改善' },
};

const IssueAlerts: FC<IssueAlertsProps> = ({ issues }) => {
    if (issues.length === 0) {
        return (
            <div style={{
                background: 'rgba(0,255,136,0.1)', border: '1px solid #00FF88',
                borderRadius: '8px', padding: '12px 16px', textAlign: 'center',
            }}>
                <span style={{ fontSize: 20 }}>✅</span>
                <p style={{ color: '#00FF88', margin: '4px 0 0', fontWeight: 600 }}>
                    姿勢良好！繼續保持
                </p>
            </div>
        );
    }

    return (
        <div className="issue-alerts" style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <h4 style={{ color: '#aaa', fontSize: 12, margin: '0 0 4px', textTransform: 'uppercase' }}>
                偵測到的問題 ({issues.length})
            </h4>
            {issues.map((issue, idx) => {
                const style = SEVERITY_STYLES[issue.severity];
                return (
                    <div
                        key={idx}
                        style={{
                            borderLeft:   `3px solid ${style.border}`,
                            background:   style.bg,
                            borderRadius: '0 8px 8px 0',
                            padding:      '10px 14px',
                            transition:   'all 0.3s ease',
                        }}
                    >
                        {/* 標題行 */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                            <span>{style.icon}</span>
                            <span style={{ fontSize: 11, color: style.border, fontWeight: 600 }}>
                {style.label}
              </span>
                            {issue.offsetValue !== undefined && (
                                <span style={{ fontSize: 10, color: '#888', marginLeft: 'auto' }}>
                  偏差：{issue.offsetValue.toFixed(1)}
                </span>
                            )}
                        </div>
                        {/* 問題說明 */}
                        <p style={{ margin: 0, fontSize: 12, color: '#ddd', lineHeight: 1.5 }}>
                            {issue.message}
                        </p>
                    </div>
                );
            })}
        </div>
    );
};

export default IssueAlerts;
